import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode(" Please fill out all the required fields with the red asterisk ("),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*"),
  /*#__PURE__*/_createTextVNode(") ")
], -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-gray-200" }, null, -1)
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = { class: "col-span-2" }
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "temporary_staff_trainee",
  class: "block mb-5 text-xs font-semibold text-neutral-600"
}, "Temporary Staff/Trainee?", -1)
const _hoisted_14 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_15 = { class: "col-span-2" }
const _hoisted_16 = { class: "col-span-1" }

import SectionTitle from "@/components/partials/SectionTitle.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import { numberonly } from "@/components/composables/useNumberOnly";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { PersonnelStatus } from "../enums/PersonnelStatus";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
	form: {
		type: Object,
		required: true,
	},
	errors: {
		type: Object,
		required: true,
	},
	departments: {
		type: Array,
		required: true,
	},
	positions: {
		type: Array,
		required: true,
	},
	userGroups: {
		type: Array,
		required: true,
	},
	offices: {
		type: Array,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	canChangeRole: {
		type: Boolean,
		default: true,
	},
},
  setup(__props) {

const props = __props;

const route = useRoute();
const form = ref<object>(props.form);

const userOffice = ref();
userOffice.value =  JSON.parse(localStorage.getItem('user')); 
const status = [
    { id: 1, value: 1, label: 'Active' },
    { id: 0, value: 0, label: 'In-Active' },
];

onMounted(()=> {
    if (!route.params?.personnel) {
        form.value.office_id = userOffice.value.office_id;
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTitle, {
      fontSmall: "",
      title: "Personnel Information"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("form", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          type: "email",
          label: "Email Address",
          placeholder: "Email address",
          name: "email_address",
          id: "email",
          disabled: __props.disabled || _unref(route).params?.personnel,
          required: "",
          modelValue: form.value.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
          error: __props.errors?.email
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TextInput, {
          type: "text",
          label: "Last Name",
          placeholder: "Last name",
          name: "last_name",
          id: "last_name",
          disabled: __props.disabled,
          required: "",
          modelValue: form.value.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.last_name) = $event)),
          error: __props.errors?.last_name
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(TextInput, {
          type: "text",
          label: "First Name",
          placeholder: "First name",
          name: "first_name",
          id: "first_name",
          disabled: __props.disabled,
          required: "",
          modelValue: form.value.first_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.first_name) = $event)),
          error: __props.errors?.first_name
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(TextInput, {
          type: "text",
          label: "Middle Name",
          placeholder: "Middle name",
          name: "middle_name",
          id: "middle_name",
          disabled: __props.disabled,
          modelValue: form.value.middle_name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.middle_name) = $event)),
          error: __props.errors?.middle_name
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(TextInput, {
          type: "tel",
          label: "Contact Number",
          placeholder: "Contact number",
          name: "contact_number",
          id: "mobile_number",
          add_on_left: true,
          add_on_text: "+63",
          maxlength: 10,
          disabled: __props.disabled,
          required: "",
          onKeypress: _unref(numberonly),
          modelValue: form.value.mobile_number,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.mobile_number) = $event)),
          error: __props.errors?.mobile_number
        }, null, 8, ["disabled", "onKeypress", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(TextInput, {
          type: "text",
          label: "Home Address",
          placeholder: "Home address",
          name: "home_address",
          id: "home_address",
          disabled: __props.disabled,
          modelValue: form.value.home_address,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.home_address) = $event)),
          error: __props.errors?.home_address
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: status,
          id: "status_id",
          name: "status",
          label: "Status",
          placeholder: "Select..",
          disabled: __props.disabled,
          readonly: __props.disabled,
          required: "",
          modelValue: form.value.is_active,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.is_active) = $event)),
          error: __props.errors?.is_active
        }, null, 8, ["disabled", "readonly", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(CheckboxInput, {
          id: "is_temporary",
          name: "temporary_staff_trainee",
          label: "Yes",
          disabled: __props.disabled,
          readonly: __props.disabled,
          checked: form.value.is_temporary,
          modelValue: form.value.is_temporary,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.is_temporary) = $event)),
          error: __props.errors?.is_temporary
        }, null, 8, ["disabled", "readonly", "checked", "modelValue", "error"])
      ]),
      (form.value.is_temporary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(MultiSelect, {
              searchable: "",
              options: __props.departments,
              id: "department_id",
              name: "department",
              label: "Department (if temporary staff/trainee)",
              placeholder: "Select..",
              disabled: __props.disabled,
              readonly: __props.disabled,
              required: "",
              modelValue: form.value.department_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.department_id) = $event)),
              error: __props.errors?.department_id
            }, null, 8, ["options", "disabled", "readonly", "modelValue", "error"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: __props.offices,
          id: "office_id",
          name: "office",
          label: "Office",
          placeholder: "Select..",
          disabled: __props.disabled,
          readonly: __props.disabled,
          required: "",
          modelValue: form.value.office_id,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.office_id) = $event)),
          error: __props.errors?.office_id
        }, null, 8, ["options", "disabled", "readonly", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (__props.canChangeRole)
          ? (_openBlock(), _createBlock(MultiSelect, {
              key: 0,
              searchable: "",
              options: __props.userGroups,
              id: "role_id",
              name: "user_group",
              label: "User Group (Role)",
              placeholder: "Select..",
              disabled: __props.disabled,
              readonly: __props.disabled,
              required: "",
              modelValue: form.value.role_id,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.role_id) = $event)),
              error: __props.errors?.role_id
            }, null, 8, ["options", "disabled", "readonly", "modelValue", "error"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([
				__props.canChangeRole ? 'col-span-1' : 'col-span-2'
			])
      }, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: __props.positions,
          id: "position_id",
          name: "position",
          label: "Position",
          placeholder: "Select..",
          disabled: __props.disabled,
          required: "",
          modelValue: form.value.position_id,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.position_id) = $event)),
          error: __props.errors?.position_id
        }, null, 8, ["options", "disabled", "modelValue", "error"])
      ], 2),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})